/**
 * Prevents Yotpo widget flash by hiding widgets until they're ready
 * and showing them with a fade-in transition.
 */

(function() {
  'use strict';

  // Check if :has() is supported
  const hasHasSupport = CSS.supports('selector(:has(*))');

  /**
   * Show Yotpo widgets that are ready
   */
  function showReadyWidgets() {
    const widgets = document.querySelectorAll('.custom-product-card .yotpo-widget-instance:not(.yotpo-ready)');
    
    widgets.forEach(widget => {
      // Check if widget has content
      const hasContent = widget.querySelector('.yotpo-sr-bottom-line-summary') !== null;
      
      if (hasContent) {
        widget.classList.add('yotpo-ready');
      }
    });
  }

  /**
   * Initialize widget visibility watcher
   */
  function init() {
    // Watch for Yotpo widgets being added to the DOM
    const observer = new MutationObserver(() => {
      showReadyWidgets();
    });

    // Observe the document for new widgets
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initial check
    showReadyWidgets();

    // Also check periodically in case Yotpo loads asynchronously
    let checkCount = 0;
    const maxChecks = 20; // Check for up to 4 seconds (20 * 200ms)
    const checkInterval = setInterval(() => {
      showReadyWidgets();
      checkCount++;
      if (checkCount >= maxChecks) {
        clearInterval(checkInterval);
      }
    }, 200);

    // Final check after a delay to catch any late-loading widgets
    setTimeout(() => {
      showReadyWidgets();
      clearInterval(checkInterval);
    }, 2000);
  }

  // Only initialize JavaScript fallback if :has() is not supported
  if (!hasHasSupport) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  // Also listen for Yotpo's own events if available (works for both CSS and JS fallback)
  if (typeof window !== 'undefined') {
    document.addEventListener('yotpo:widget:ready', showReadyWidgets);
    window.addEventListener('yotpo:init', showReadyWidgets);
  }
})();

